export const DRAWER_ID = 'awp-host-config-rule-drawer';
